import { notifications } from '@mantine/notifications';
import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next';

export const mutateChangelogDelete = ({ entryId }) => {
    const { t } = useTranslation();

    const mutation = useMutation({
        mutationKey: ['changelog-delete', entryId],
        mutationFn: async () => {
            const res = await axios.delete(route('studio.v1.api.changelog.destroy', entryId));
            return res;
        },
        onSuccess: async ({ data }) => {
            notifications.show({
                color: 'green',
                title: t('common.success'),
                message: t('changelog.entry.deleted'),
            })
        },
        onError: async ({ response }) => {
            notifications.show({
                color: 'red',
                title: t('common.error'),
                message: response?.data?.message || '',
            })
        }
    });

    return mutation;
}
